export default "__VITE_ASSET__VYt1U6U2__"